import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogContent, Grid } from '@mui/material';
import { WsButton, WsDialog, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const NotifyPaymentMethodChange = ({ onClose }: { onClose: () => void }) => (
  <WsDialog size="small" openDialog={true} onClose={onClose}>
    <DialogContent>
      <CloseIcon sx={{ float: 'right' }} onClick={onClose} />
      <Grid item xs={12} textAlign="center">
        <WsTypography variant={WsTypoVariants.TITLE} bold color={WsTypoColors.PRIMARY}>
          Payment Method Change
        </WsTypography>
        <Box mt={2} mb={2}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>
            We have informed our team that you want to change your payment method for your current
            Subscription. Rest assured! Our Customer success team will soon contact you to solve
            your problem
          </WsTypography>
        </Box>
        <WsButton onClick={onClose}>Close</WsButton>
      </Grid>
    </DialogContent>
  </WsDialog>
);

export default NotifyPaymentMethodChange;
